<template>
  <div>
    <div class="tabela-container">
      <table class="tabela">
        <thead>
          <th class="sem-borda"></th>
          <th v-for="categoria in xaxis" :key="categoria.index">
            {{ categoria }}
          </th>
        </thead>
        <tbody>
          <tr>
            <td class="titulo_td">
              <div
                class="barrinha"
                :style="{
                  background: chartOptions.colors[0],
                }"
              ></div>
              <span>Município</span>
            </td>

            <td
              v-for="(serieMunicipio, index) in arrayChartMunicipio"
              :key="`${index} + ${serieMunicipio}`"
            >
              {{ serieMunicipio }}
            </td>
          </tr>

          <tr
            v-if="
              arrayChartEquipe !== null &&
              equipe !== '' &&
              equipe !== 'sem-equipe'
            "
          >
            <td class="titulo_td">
              <div
                class="barrinha"
                :style="{
                  background: chartOptions.colors[1],
                }"
              ></div>
              <span>Equipe</span>
            </td>
            <td
              v-for="(serieEquipe, index) in arrayChartEquipe"
              :key="`${index} + ${serieEquipe}`"
            >
              {{ serieEquipe }}
            </td>
          </tr>
          <tr
            v-if="
              arrayChartAcs !== null &&
              profissional !== '' &&
              profissional !== 'todos'
            "
          >
            <td class="titulo_td">
              <div
                class="barrinha"
                :style="{
                  background: chartOptions.colors[2],
                }"
              ></div>
              <span>ACS</span>
            </td>
            <td
              v-for="(serieAcs, index) in arrayChartAcs"
              :key="`${index} + ${serieAcs}`"
            >
              {{ serieAcs }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabelaSerieHistorica',
  props: {
    xaxis: {
      type: Array,
      default: () => {},
    },
    chartOptions: {
      type: Object,
      default: () => {},
    },
    arrayChartMunicipio: {
      type: Array,
      default: () => {},
    },
    arrayChartEquipe: {
      type: Array,
      default: () => {},
    },
    arrayChartAcs: {
      type: Array,
      default: () => {},
    },
    equipe: {
      type: [String, Object],
      default: () => {},
    },
    profissional: {
      type: [String, Object],
      default: () => {},
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.tabela-container {
  overflow-x: scroll;
}

.tabela {
  margin: 60px auto;
}

th,
td {
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
}
td:first-child {
  border-top: unset;
  border-right: unset;
}
th:first-child {
  border-top: unset;
  border-left: unset;
}
.barrinha {
  width: 35px;
  height: 5px;
  display: block;
  border-radius: 10px;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
.titulo_td {
  display: flex;
  align-items: center;
  gap: 5px;
}
.sem-borda {
}
thead {
  border-top: unset;
  border-left: unset;
}
</style>
